const nonSixthBodyOutfits: Record<string, boolean> = {
  '889161': true,
  '889163': true,
  '889164': true,
  '889165': true,
  '889167': true,
  '889168': true,
  '889169': true,
  '889171': true,
  '889173': true,
  '889174': true,
  '889175': true,
  '889176': true,
  '889177': true,
  '889178': true,
  '889196': true,
  '889198': true,
  '889199': true,
  '889201': true,
  '889202': true,
  '889203': true,
  '889204': true,
  '889205': true,
  '889206': true,
  '889207': true,
  '889213': true,
  '889219': true,
  '889220': true,
  '889221': true,
  '889222': true,
  '889223': true,
  '889224': true,
  '889231': true,
  '889232': true,
  '889233': true,
  '889235': true,
  '889236': true,
  '889238': true,
  '889499': true,
  '889502': true,
  '889503': true,
  '889504': true,
  '889506': true,
  '889507': true,
  '889508': true,
  '889510': true,
  '889513': true,
  '889514': true,
  '889515': true,
  '889516': true,
  '889517': true,
  '889518': true,
  '901021': true,
  '901022': true,
  '901023': true,
  '901024': true,
  '901027': true,
  '901028': true,
  '901029': true,
  '901030': true,
  '901031': true,
  '901032': true,
  '901033': true,
  '901034': true,
  '923267': true,
  '923268': true,
  '923270': true,
  '923271': true,
  '923273': true,
  '923275': true,
  '944134': true,
  '944135': true,
  '944136': true,
  '944137': true,
  '944138': true,
  '944139': true,
  '944140': true,
  '944141': true,
  '944142': true,
  '944143': true,
  '944144': true,
  '944145': true,
  '957105': true,
  '957106': true,
  '957107': true,
  '957109': true,
  '957110': true,
  '957113': true,
  '957114': true,
  '957995': true,
  '957996': true,
  '957997': true,
  '957998': true,
  '962365': true,
  '962366': true,
  '962367': true,
  '962369': true,
  '962370': true,
  '962371': true,
  '965966': true,
  '965968': true,
  '965970': true,
  '965971': true,
  '965972': true,
  '965973': true,
  '965976': true,
  '965977': true,
  '965978': true,
  '965979': true,
  '965980': true,
  '965982': true,
  '965984': true,
  '965985': true,
  '965986': true,
  '971782': true,
  '971785': true,
  '971786': true,
  '975582': true,
  '975586': true,
  '975587': true,
  '975588': true,
  '975592': true,
  '975593': true,
  '975594': true,
  '975596': true,
  '975597': true,
  '975598': true,
  '978520': true,
  '978521': true,
  '978522': true,
  '978524': true,
  '978525': true,
  '978526': true,
  '983112': true,
  '986556': true,
  '986557': true,
  '986558': true,
  '986560': true,
  '986562': true,
  '986564': true,
  '990486': true,
  '990487': true,
  '990488': true,
  '990489': true,
  '990490': true,
  '990491': true,
  '990492': true,
  '990493': true,
  '990494': true,
  '990495': true,
  '990496': true,
  '990497': true,
  '997990': true,
  '997992': true,
  '997993': true,
  '997995': true,
  '997996': true,
  '997997': true,
  '1000635': true,
  '1000636': true,
  '1000637': true,
  '1000638': true,
  '1000639': true,
  '1000640': true,
  '1000643': true,
  '1000644': true,
  '1000645': true,
  '1000646': true,
  '1000647': true,
  '1000649': true,
  '1003345': true,
  '1003347': true,
  '1005740': true,
  '1005748': true,
  '1005750': true,
  '1005751': true,
  '1005752': true,
  '1005753': true,
  '1005755': true,
  '1005756': true,
  '1005757': true,
  '1005758': true,
  '1005759': true,
  '1017604': true,
  '1017605': true,
  '1017606': true,
  '1017608': true,
  '1017609': true,
  '1017610': true,
  '1017612': true,
  '1017613': true,
  '1017614': true,
  '1017615': true,
  '1017859': true,
  '1017860': true,
  '1017861': true,
  '1017862': true,
  '1017863': true,
  '1017864': true,
  '1017869': true,
  '1017870': true,
  '1017871': true,
  '1017874': true,
  '1017875': true,
  '1017876': true,
  '1017878': true,
  '1017881': true,
  '1017882': true,
  '1017883': true,
  '1017885': true,
  '1017887': true,
  '1017888': true,
  '1017889': true,
  '1017891': true,
  '1017893': true,
  '1017894': true,
  '1017895': true,
  '1017896': true,
  '1017897': true,
  '1017898': true,
  '1017899': true,
  '1017900': true,
  '1017901': true,
  '1017933': true,
  '1017934': true,
  '1017935': true,
  '1017945': true,
  '1017946': true,
  '1017947': true,
  '1017948': true,
  '1017949': true,
  '1017950': true,
  '1017951': true,
  '1017952': true,
  '1017953': true,
  '1017954': true,
  '1017955': true,
  '1017956': true,
  '1017961': true,
  '1017962': true,
  '1017963': true,
  '1017964': true,
  '1017965': true,
  '1017966': true,
  '1017967': true,
  '1017968': true,
  '1017969': true,
  '1017970': true,
  '1017971': true,
  '1017972': true,
  '1018015': true,
  '1018016': true,
  '1018027': true,
  '1018028': true,
  '1018029': true,
  '1018030': true,
  '1018031': true,
  '1018032': true,
  '1018033': true,
  '1018034': true,
  '1018035': true,
  '1018036': true,
  '1018037': true,
  '1018039': true,
  '1018044': true,
  '1018045': true,
  '1018046': true,
  '1018047': true,
  '1018048': true,
  '1018049': true,
  '1018050': true,
  '1018051': true,
  '1018052': true,
  '1018053': true,
  '1018054': true,
  '1018055': true,
  '1018072': true,
  '1018073': true,
  '1018074': true,
  '1018075': true,
  '1018076': true,
  '1018077': true,
  '1018078': true,
  '1018079': true,
  '1018080': true,
  '1018081': true,
  '1018082': true,
  '1018083': true,
  '1018091': true,
  '1018092': true,
  '1018093': true,
  '1018094': true,
  '1018095': true,
  '1018096': true,
  '1018097': true,
  '1018098': true,
  '1018099': true,
  '1018100': true,
  '1018101': true,
  '1018102': true,
  '1018110': true,
  '1018111': true,
  '1018112': true,
  '1018113': true,
  '1018114': true,
  '1018115': true,
  '1018116': true,
  '1018117': true,
  '1018118': true,
  '1018119': true,
  '1018120': true,
  '1018121': true,
  '1018139': true,
  '1018140': true,
  '1018141': true,
  '1018142': true,
  '1018143': true,
  '1018144': true,
  '1018145': true,
  '1018146': true,
  '1018147': true,
  '1018148': true,
  '1018149': true,
  '1018150': true,
  '1018152': true,
  '1018153': true,
  '1018154': true,
  '1018156': true,
  '1018157': true,
  '1018234': true,
  '1018235': true,
  '1018236': true,
  '1018237': true,
  '1018238': true,
  '1018239': true,
  '1018240': true,
  '1018241': true,
  '1018242': true,
  '1018243': true,
  '1018244': true,
  '1018245': true,
  '1018248': true,
  '1018249': true,
  '1018250': true,
  '1018251': true,
  '1018252': true,
  '1018253': true,
  '1018254': true,
  '1018255': true,
  '1018256': true,
  '1018257': true,
  '1018258': true,
  '1018259': true,
  '1018272': true,
  '1018273': true,
  '1018274': true,
  '1018275': true,
  '1018276': true,
  '1018277': true,
  '1018278': true,
  '1018279': true,
  '1018280': true,
  '1018281': true,
  '1018282': true,
  '1018283': true,
  '1018284': true,
  '1018285': true,
  '1018286': true,
  '1018287': true,
  '1018288': true,
  '1018289': true,
  '1018290': true,
  '1018291': true,
  '1018292': true,
  '1018293': true,
  '1018294': true,
  '1018295': true,
  '1018469': true,
  '1018470': true,
  '1018471': true,
  '1018472': true,
  '1018473': true,
  '1018474': true,
  '1018479': true,
  '1018480': true,
  '1018481': true,
  '1018482': true,
  '1018483': true,
  '1018484': true,
  '1018485': true,
  '1018486': true,
  '1018487': true,
  '1018488': true,
  '1018489': true,
  '1018490': true,
  '1018491': true,
  '1018492': true,
  '1018493': true,
  '1018494': true,
  '1018495': true,
  '1018496': true,
  '1018497': true,
  '1018498': true,
  '1018499': true,
  '1018500': true,
  '1018501': true,
  '1018502': true,
  '1018503': true,
  '1018504': true,
  '1018505': true,
  '1018506': true,
  '1018507': true,
  '1018508': true,
  '1018509': true,
  '1018510': true,
  '1018511': true,
  '1018512': true,
  '1018513': true,
  '1018514': true,
  '1018515': true,
  '1018516': true,
  '1018517': true,
  '1018518': true,
  '1018519': true,
  '1018520': true,
  '1018521': true,
  '1018522': true,
  '1018523': true,
  '1018524': true,
  '1018525': true,
  '1018526': true,
  '1018528': true,
  '1018529': true,
  '1018530': true,
  '1018531': true,
  '1018532': true,
  '1018533': true,
  '1018534': true,
  '1018535': true,
  '1018536': true,
  '1018537': true,
  '1018538': true,
  '1018539': true,
  '1018540': true,
  '1018541': true,
  '1018542': true,
  '1018543': true,
  '1018544': true,
  '1018545': true,
  '1018546': true,
  '1018547': true,
  '1018548': true,
  '1018549': true,
  '1018550': true,
  '1018551': true,
  '1018552': true,
  '1018553': true,
  '1018554': true,
  '1018555': true,
  '1018556': true,
  '1018557': true,
  '1018558': true,
  '1018559': true,
  '1018563': true,
  '1018564': true,
  '1018565': true,
  '1018566': true,
  '1018567': true,
  '1018568': true,
  '1018569': true,
  '1018570': true,
  '1018571': true,
  '1018572': true,
  '1018573': true,
  '1018574': true,
  '1018575': true,
  '1018576': true,
  '1018577': true,
  '1018578': true,
  '1018579': true,
  '1018580': true,
  '1018581': true,
  '1018582': true,
  '1018583': true,
  '1018584': true,
  '1018585': true,
  '1018586': true,
  '1018587': true,
  '1018588': true,
  '1018589': true,
  '1018590': true,
  '1018591': true,
  '1018592': true,
  '1018593': true,
  '1018594': true,
  '1018595': true,
  '1018596': true,
  '1018597': true,
  '1018598': true,
  '1018599': true,
  '1018600': true,
  '1018601': true,
  '1018602': true,
  '1018603': true,
  '1018604': true,
  '1018605': true,
  '1018606': true,
  '1018607': true,
  '1018608': true,
  '1018609': true,
  '1018610': true,
  '1018611': true,
  '1018612': true,
  '1018613': true,
  '1018614': true,
  '1018615': true,
  '1018616': true,
  '1018617': true,
  '1018618': true,
  '1018619': true,
  '1018620': true,
  '1018621': true,
  '1018622': true,
  '1018623': true,
  '1018624': true,
  '1018625': true,
  '1018626': true,
  '1018627': true,
  '1018628': true,
  '1018629': true,
  '1018630': true,
  '1018631': true,
  '1018632': true,
  '1018633': true,
  '1018634': true,
  '1018638': true,
  '1018639': true,
  '1018640': true,
  '1018641': true,
  '1018642': true,
  '1018643': true,
  '1018644': true,
  '1018645': true,
  '1018646': true,
  '1018647': true,
  '1018648': true,
  '1018649': true,
  '1018650': true,
  '1018651': true,
  '1018652': true,
  '1018653': true,
  '1018654': true,
  '1018655': true,
  '1018656': true,
  '1018657': true,
  '1018658': true,
  '1018659': true,
  '1018660': true,
  '1018661': true,
  '1018662': true,
  '1018665': true,
  '1018666': true,
  '1018667': true,
  '1018668': true,
  '1018669': true,
  '1018670': true,
  '1018671': true,
  '1018672': true,
  '1018673': true,
  '1018674': true,
  '1018675': true,
  '1018676': true,
  '1018677': true,
  '1018678': true,
  '1018679': true,
  '1018680': true,
  '1018681': true,
  '1018682': true,
  '1018683': true,
  '1018684': true,
  '1018685': true,
  '1018686': true,
  '1018687': true,
  '1018688': true,
  '1018689': true,
  '1018690': true,
  '1018691': true,
  '1018692': true,
  '1018693': true,
  '1018694': true,
  '1018716': true,
  '1018717': true,
  '1018718': true,
  '1018719': true,
  '1018720': true,
  '1018721': true,
  '1018722': true,
  '1018723': true,
  '1018724': true,
  '1018725': true,
  '1018726': true,
  '1018727': true,
  '1018728': true,
  '1018729': true,
  '1018730': true,
  '1018731': true,
  '1018732': true,
  '1018733': true,
  '1018734': true,
  '1018735': true,
  '1018736': true,
  '1018737': true,
  '1018738': true,
  '1018739': true,
  '1018740': true,
  '1018785': true,
};

export default {
  nonSixthBodyOutfits,
};
